import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TEXT_CONSTANTS } from '../../constants/Constants'; // Ensure this file is correctly imported

const GetStartedPage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/UserType');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#1F405A] text-white p-4">
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-white mb-6" style={{ fontFamily: "'Albert Sans', sans-serif" }}>
        {TEXT_CONSTANTS.GET_STARTED_HEADING}
      </h1>
      <p className="text-lg md:text-xl text-center mb-8 max-w-2xl" style={{ fontFamily: "'Albert Sans', sans-serif" }}>
        {TEXT_CONSTANTS.GET_STARTED_DESCRIPTION}
      </p>
      <button
        onClick={handleGetStarted}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105"
      >
        {TEXT_CONSTANTS.GET_STARTED_BUTTON_TEXT}
      </button>
    </div>
  );
};

export default GetStartedPage;
